export const mapUploadFileData = (file, type = "SUBMISSION") => ({
  filename: file.name,
  fileType: type,
  mimeType: file.type,
  size: file.size,
});
